import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import * as moment from "moment";
import {LeadAppointmentStatusEventDataApiDto, LeadEventApiDto} from "../../../api/model/rest";
import AppointmentStatus from "../../appointment/AppointmentStatus";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import DateUtils from "../../../utils/DateUtils";

/**
 * Lead appointment status changed event.
 */
export default class LeadAppointmentStatusEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param {LeadAppointmentStatusEventData} data lead appointment status change event data.
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadAppointmentStatusEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadAppointmentStatusEvent {
		const data = LeadAppointmentStatusEventData.fromJson(json.data as LeadAppointmentStatusEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadAppointmentStatusEvent(json.id, json.leadId.toString(), LeadEventTypeEnum.AppointmentStatusChanged,
			entity, moment(json.createdAt), json.referenceNumber, data);
	}

	getIcon() {
		return Icon.Appointments;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getActivityType(): string {
		return `APPOINTMENT`
	}

	getActivityMessage(): string {
		return `Status changed from ${this.statusDisplayText().capitalize()}
				to ${this.newStatusDisplayText().capitalize()}
				for ${this.data.appointmentDate.format(DateUtils.DATE_TIME_FORMAT)}`;
	}

	statusDisplayText() {
		return this.data.status.label.toLocaleLowerCase()
	}

	newStatusDisplayText() {
		return this.data.nextStatus.label.toLocaleLowerCase()
	}
}

export class LeadAppointmentStatusEventData {
	constructor(public readonly appointmentId: string,
		public readonly appointmentDate: moment.Moment,
		public readonly status: AppointmentStatus,
		public readonly nextStatus: AppointmentStatus) {}

	public static fromJson(json: LeadAppointmentStatusEventDataApiDto): LeadAppointmentStatusEventData {
		return new LeadAppointmentStatusEventData(json.id, moment(json.appointmentDate),
			AppointmentStatus.fromString(json.status),
			AppointmentStatus.fromString(json.nextStatus));
	}
}